import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Container } from '../../ui/Container';
import { Button } from '../../ui/Button';
import { SectionHeading } from '../../ui/SectionHeading';
export function WhyMatters() {
  return <section className="relative py-20 md:py-28 overflow-hidden bg-[#EDF2F7]/60" data-id="element-710" data-mp="2e1c9pboio2wj">
      <Container data-id="element-711" data-mp="2j074zd3o7jxj">
        <div className="grid lg:grid-cols-12 gap-12 items-center" data-id="element-712" data-mp="2496lmd1dy5mm">
          <div className="lg:col-span-6" data-id="element-713" data-mp="247n1ucgitcg3">
            <SectionHeading eyebrow="Why We Exist" title="Why This Initiative Matters" description="Millions of Muslim families face new realities every day. Muslim children are at risk when raised in non-Muslim communities without access to faith-aware educational and community-based support." data-id="element-714" data-mp="28zmztzd15va1" />
            <ul className="mt-8 space-y-3 text-ink-700 max-w-xl" data-id="element-715" data-mp="1lauailqwyloe">
              <li className="flex gap-3" data-id="element-716" data-mp="1q9otbnovsa8i">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-sand-400 flex-shrink-0" data-id="element-717" data-mp="1q8nj1lfovrru" />
                Most schools provide only academic learning.
              </li>
              <li className="flex gap-3" data-id="element-718" data-mp="18ftv3lwptyux">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-sand-400 flex-shrink-0" data-id="element-719" data-mp="18iy5j10rxqu1" />
                Parents face uncertainty about belonging, identity, and
                integration.
              </li>
            </ul>
            <div className="mt-8" data-id="element-720" data-mp="tr7gjmewxb4r">
              <Link to="/en/about" data-id="element-721" data-mp="tsihzfkvy6sp">
                <Button variant="gold" data-id="element-722" data-mp="tpcsw0c9b4wz">About Us</Button>
              </Link>
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1]
        }} className="lg:col-span-6 relative" data-id="element-723" data-mp="13hilncac1qd8">
            <img src="https://cdn.magicpatterns.com/uploads/5BWDsGqFyCo2fwTbkPN1RM/learning.png" alt="Watercolor illustration of a mosque surrounded by foliage" className="w-full h-auto object-contain" data-id="element-724" data-mp="263urcmlh6yfp" />
          </motion.div>
        </div>
      </Container>
    </section>;
}